import moment from "moment";

let e = {};
e.code = {};
e.code.second_parting_by = 30;
e.code.plus = (x, y) => x.toString().match(/\d/g).map(v=>parseInt(v)).map((v,i)=>(v+parseInt((y.toString().length==1?"0"+y:y.toString())[i%2])).toString().slice(-1)).join('');
e.code.makeSecret = (spice, secret)=>{
	let time = moment();
	let minute = time.format("mm");
    let second_part = Math.ceil(Number(time.format("ss"))/e.code.second_parting_by);
    if(second_part == 0) second_part = 1;
	let numbers = [spice*second_part, time.format("DD") ,time.format("MM"),minute,time.format("YYYY"),spice.toString().length];
	let result = secret.toString()+minute+second_part;
    for(let num of numbers) result = e.code.plus(result, num);
	return result;
}

export default e;